export enum SettingsOption {
    GENERAL = 'General',
    TIPURI_CERERE = 'Tipuri Cereri',
    PRIORITATE_CERERE = 'Prioritate Cerere',
    STATUS_CERERE = 'Status Cerere',
    SABLOANE_CERERE = 'Șabloane Cereri',
    CATEGORII_DOCUMENTE = 'Categorii Documente',
    TIPURI_DOCUMENTE = 'Tipuri Documente',
    TEMPLATE_DOCUMENTE = 'Template Documente',
    CATEGORII_TEMPLATE = 'Categorii Template',
    REGISTRE = 'Registre',
    OPERATORI = 'Operatori',
    ZILE_LIBERE = 'Zile libere',
    PROGRAMARI_ACTIVITATI = 'Programări Activități',
    MOTIVE_REFUZ = 'Motive Refuz',
}

export enum SettingsActivitiesOption {
    SITUATIE_CURENTA_COPIL = 'Act: Situație curentă copil',
    GRUP_ATRIBUTE_COPII = 'Act: Grup atribute copii',
    ATRIBUTE_COPII = 'Act: Atribute copii',
    TIPURI_DATE_COPII = 'Act: Tipuri de date',
    STATUS_EVENIMENT_COPIL = 'Act: Status eveniment copil',
    PRIORITATE_EVENIMENT_COPIL = 'Act: Prioritate eveniment copil',
    ENTITATE_INRUDITA_TYPE = 'Social: Tip entitate înrudită',
    RELATIE_TYPE = 'Social: Tip relație',
    CUSTODIE_TYPE = 'Social: Tip custodie',
    RELATIE_STATUS = 'Social: Status relație',
    CAPACITATE_CRESTERE_COPIL = 'Social: Capacitate părinte creștere copil',
    NIVEL_RISC = 'Social: Nivel de risc',
    STATUS_LEGAL = 'Social: Status legal',
    CONTACT_FRECVENTA = 'Social: Contact frecvență',
    PARTEA_RELATIEI = 'Social: Partea relației',
    RELATIE_SPECIFICA_SEX = 'Social: Relație specifică în funcție de sex',
    CONFIRMARE_RELATIE = 'Social: Status confirmare relație',
    ADRESE_CENTRE = 'Adrese: Centre DGASPC',
}

export enum SettingsActivitiesDocsOption {
    DOCUMENT_STATUSES = 'DOC: Status',
    DOCUMENT_PRIORITIES = 'DOC: Prioritate',
    DOCUMENT_CATEGORIES = 'DOC: Categorii',
    DOCUMENT_TAGS = 'DOC: Tags',
    DOCUMENT_TYPE = 'DOC: Tipuri',
    DOCUMENT_SECTIONS = 'DOC: Secțiuni medicale',
    EVENIMENT_GENEALOGIC_TYPE = 'Medical: Tip eveniment genealogic',
    CONDITIE_MEDICALA_TYPE = 'Medical: Tip condiție medicală',
}

export enum SettingsActivitiesProgOption {
    MODULE = 'Module',
    LOCATII = 'Locații',
    ZILE_LIBERE = 'Zile libere',
    SPECIALIZARI = 'Specializări',
    STATUSURI = 'Statusuri',
    PRIORITATI = 'Priorități',
    OPERATORI = 'Operatori',
    TIPURI_PROBLEME = 'Tipuri probleme',
    PROGRAM = 'Configurare program',
}

export enum AdminSettings {
    CONFIGURARI = 'Configurări',
    TYPE_IMAGE_DIMENSIONS = 'Dimensiuni Tip Imagini',
    CRONS = 'Cron-uri',
}
